import ApplicationController from './application_controller';

export default class extends ApplicationController {
  connect() {
    this.onScrollRunning = false;
    this.onScroll();
  }

  onScroll() {
    if (this.onScrollRunning) return;

    this.onScrollRunning = true;

    const sticky = this.element.offsetTop;

    if (window.pageYOffset > sticky) {
      this.element.classList.add('bg-gray-800');
      this.element.classList.remove('bg-transparent');
    } else {
      this.element.classList.add('bg-transparent');
      this.element.classList.remove('bg-gray-800');
    }
    
    this.onScrollRunning = false;
  }
}
